/*
 * @Author: Dong
 * @Date: 2022-04-12 13:50:42
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-08-25 16:18:21
 */
import request from 'root/utils/request';

const basePath = '/api/ops-manager/v1/supos/manager';
const basePathV2 = '/api/ops-manager/v2/supos/manager';

// 检验环境
export const checkEnv = async (params?: any) => {
  return request.get(`${basePath}/env`, { params: { ...params } });
};

// 获取平台配置(supos)信息
export const getSuposAllConfig = async (params?: any) => {
  return request.get(`/api/ops-manager/v1/product/env/config`, { params: { ...params } });
};

// 获取平台配置(supos)信息
export const newGetSuposAllConfig = async (params?: any) => {
  return request.get(`/api/ops-manager/v1/product/env/conf`, { params: { ...params } });
};

/**
 * 修改平台配置文件
 * @param payload 配置信息
 * @param productName  产品信息
 * @returns
 */
export const modifySuposConfig = async (payload: any, productName?: String) => {
  if (!productName) {
    return request.put(`/api/ops-manager/v1/product/env/config`, payload);
  } else {
    return request.put(`/api/ops-manager/v1/product/env/conf/${productName}`, payload);
  }
};

// 上传包
export const uploadModule = async (file: any, onUploadProgress: (progressEvent: any) => void, cancelToken: any) => {
  return request.post(`/api/ops-manager/v2/supos/manager/packages`, file, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    cancelToken: cancelToken,
    onUploadProgress: onUploadProgress,
  });
};

// 获取已上传的安装包列表
export const getPkgVersions = async () => {
  return request.get(`${basePath}/packages`);
};

// 获取已安装列表
export const getComponents = async () => {
  return request.get(`${basePath}/productlist`);
};

// 安装
export const install = async (params: any) => {
  return request.post(`${basePathV2}/install`, params);
};

// 重新安装
export const reinstallApi = async (params: any) => {
  return request.post(`${basePathV2}/reinstall`, params);
};

// 继续安装 恢复/暂停  (operate 1:暂停 2:恢复  )
export const installOperateApi = async (operate: number) => {
  return request.get(`${basePathV2}/install/${operate}`);
};

// 卸载列表
export const unInstall = async (params: any) => {
  return request.post(`${basePathV2}/uninstall`, params);
};

// 依赖组件(卸载组件前判断是否有依赖)
export const dependentList = async (params: any) => {
  return request.post(`${basePathV2}/uninstall/check`, params);
};

// 分区状态
export const getPartitionStatusApi = async () => {
  return request.get(`${basePath}/partition`);
};

// 取消任务
export const cancelTask = async (param: any) => {
  return request.post(`${basePath}/cancel`, param);
};

// 设置supplant配置
export const setSupplantConfig = async (params: any) => {
  return request.put(`${basePath}/config`, params);
};

// 设置任务为成功
export const setTaskSuccess = async (params: any) => {
  return request.put(`${basePath}/task/success`, params);
};

// 获取supos访问地址
export const getUrl = async () => {
  return request.get(`${basePath}/web/url`);
};

// 获取日志记录
export const getLogData = async (params?: any) => {
  return request.get(`${basePath}/web/url`, {
    params: { ...params },
  });
};

// 获取备份文件列表
export const getBackupList = async (params?: any) => {
  return request.get(`${basePath}/web/url`, {
    params: { ...params },
  });
};

// 获取产品状态 如supos
export const getSuposStatusApi = async (params: any) => {
  return request.post(`${basePath}/status`, params);
};

// 验证数据库连接
export const checkDatabaseConnection = async (params: any) => {
  return request.post(`${basePath}/valid`, params);
};

// 验证ssh连接
export const checkSshConnection = async (params: any) => {
  return request.post(`${basePath}/ssh`, params);
};

// 获取实例名称
export const getInstanceName = async (params?: any) => {
  return request.get(`/api/ops-manager/v1/supos/runtime_env/version`, { params: { ...params } });
};
//  修改实例名称
export const updateInstanceName = async (params: any) => {
  return request.post(`/api/ops-manager/v1/supos/runtime_env/name`, params);
};

//   下载安装检查日志
export const downloadInstlallLog = async () => {
  return request.get(`/api/ops-manager/v1/supos/check/log/download`, {
    responseType: 'blob',
  });
};

// 获取服务信息 /扩展服务
export const getSummaryApi = async () => {
  return request.get(`${basePath}/summary`);
};

// 检查安装包依赖关系
export const checkDependenciesApi = async (params: any) => {
  return request.post(`${basePath}/summary`, params);
};

// 发起安装前检查
export const checkInstallApi = async (params: { type: string }) => {
  return request.post(`/api/ops-manager/v1/supos/check`, params);
};
// 查询安装检查状态
export const checkInstallStatusApi = async () => {
  return request.get(`/api/ops-manager/v1/supos/check`);
};

// 查询安装检查需要修改的配置文件
export const getFileApi = async (params: any) => {
  return request.post(`/api/ops-manager/v1/supos/check/config/show`, params);
};

// 查询安装检查需要修改的配置文件
export const updateFileApi = async (params: any) => {
  return request.post(`/api/ops-manager/v1/supos/check/config/flush`, params);
};

// 结束检测
export const checkQuitApi = async () => {
  return request.post(`/api/ops-manager/v1/supos/check/quit`);
};
// 获取检测任务状态
export const checkTaskStatusApi = async () => {
  return request.get(`/api/ops-manager/v1/supos/check/status`);
};

// 获取错误日志
export const downloadLog = async (name: string) => {
  return request.get(`/api/ops-manager/v1/supos/manager/log/download/${name}`, {
    responseType: 'blob',
  });
};

// 获取节点配置列表(安装流程)
export const nodeConfigListApi = async () => {
  return request.get(`/api/ops-manager/v1/supos/node/query`);
};

// 获取安装包表单配置信息
export const packForms = async () => {
  return request.get(`/api/ops-manager/v1/product/env/conf/all`);
};

// 取消安装supos TODO
export const cancelSuposIntall = async () => {
  return request.get(``);
};

// 中间件部署方式
export const middlewareDeployModeApi = async () => {
  return request.get(`/api/ops-manager/v1/supos/node/deploy_mode`);
};

// 设置租户模式
export const setTenantApi = async (params: { isMutiTenant: boolean; domamin: string }) => {
  return request.post(`/api/ops-manager/v1/product/env/multi_tenant`, params);
};

// 获取数据库类型
export const getDatabseListApi = async (type: string) => {
  return request.get(`/api/ops-manager/v1/supos/manager/support/db/${type}`);
};

// 获取语言列表
export const getLanguageApi = async () => {
  return request.get(`/api/ops-manager/v1/supos/manager/support/language`);
};
